<template>
  <ion-page>
  
    <ion-content :fullscreen="true">
      <div class="container-fluid m-0 p-0 principal bg-dark">

        <div class="fondo-lg fondo1"></div>

        <div class="row justify-content-end m-0 p-0" style="min-height:100vh;"> 
          <div class="col-xl-6 col-lg-6 col-md-4 col-sm-12 p-0 text-white d-none d-md-block" style="margin-top: 15%;">
            <div class="container-fluid h-100">
              <div class="row justify-content-end">
                <div class="col-lg-6 col-sm-12 text-center p-0">
                  <img style="width:100px; margin:auto; display:block; border-radius:25px;" src="assets/imgs/icon.png"/>
                  <h4 class="mr-4 ml-4 mb-0 mt-4 animated fadeInDownBig">PLATAFORMA DE AYUDA</h4>  
                  <hr class="mt-4 mb-4 bg-white"/> 
                  <h6 class="animated fadeIn mt-2 mt-md-0 ml-2 mr-2">INVERLUZ S.A.</h6> 
                </div>
              </div>
              <div v-if="muestraTurnos" class="row justify-content-center align-items-center mt-2 h-50">
                <div class="col-lg-7 col-sm-12 text-center p-0">
                  <div v-for="turno in turnos" :key="turno.trn_id" class="card border-white fondo-transparente p-2 m-1" style="font-family: arial;">
                    <h6 class="mt-2" style="font-size: small;">{{ turno.trn_nombre }}</h6>
                    <h6 class="font-weight-bold mb-1">{{ turno.usuario.usr_nombres+' '+turno.usuario.usr_apellido_p+' '+turno.usuario.usr_apellido_m }}</h6>
                    <div class="row" style="font-size: small;">
                      <div class="col-6"><p>+56 {{ turno.usuario.usr_telefono }}</p></div>
                      <div class="col-6"><p> {{ turno.usuario.usr_correo }}</p></div>
                    </div>
                    <p style="text-align: justify; font-size: small;">{{ turno.trn_mensaje }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-6 col-lg-6 col-md-4 col-sm-12 p-0 pt-5 text-white d-sm-block d-md-none fondo-sm fondo1">
            <div class="container-fluid">
              <div class="row justify-content-end pl-3 pr-3">
                <div class="col-lg-6 col-sm-12 text-center p-0">
                  <img style="width:50px; margin:auto; display:block; border-radius:15px;" src="assets/imgs/icon.png"/>
                  <h4 class="mr-4 ml-4 mb-0 mt-2 animated fadeInDownBig">PLATAFORMA DE AYUDA</h4>  
                  <h6 class="animated fadeIn mt-2">INVERLUZ S.A.</h6> 
                </div>
              </div>
              <div v-if="muestraTurnos" class="row justify-content-center align-items-center mt-2 h-50">
                <div class="col-lg-6 col-sm-12 text-center p-0">
                  <div v-for="turno in turnos" :key="turno.trn_id" class="card border-white fondo-transparente p-2 m-1" style="font-family: arial;">
                    <h6 class="mt-2" style="font-size: small;">{{ turno.trn_nombre }}</h6>
                    <h6 class="font-weight-bold mb-1">{{ turno.usuario.usr_nombres+' '+turno.usuario.usr_apellido_p+' '+turno.usuario.usr_apellido_m }}</h6>
                    <div class="row" style="font-size: small;">
                      <div class="col-6"><p>+56 {{ turno.usuario.usr_telefono }}</p></div>
                      <div class="col-6"><p> {{ turno.usuario.usr_correo }}</p></div>
                    </div>
                    <p style="text-align: justify; font-size: small;">{{ turno.trn_mensaje }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-6 col-lg-6 col-md-8 col-sm-12 p-3 text-center bg-white text-dark" style="min-height:100%;">
            <div class="container-fluid pb-4" style="height:100%;">
              
              <div class="row justify-content-center pt-5">
                <ion-row v-if="cargando" class="ion-justify-content-center ion-margin-top ion-padding-top">
                  <ion-col size="12">
                    <ion-spinner class="text-dark" name="lines" style="width:80px; height:80px;"></ion-spinner>
                  </ion-col>
                  <ion-col size="12">
                    <ion-label class="text-dark">CARGANDO..</ion-label>
                  </ion-col>
                </ion-row>
                <div v-else class="col-lg-6 col-md-12 col-sm-12 mt-4" style="min-height: 60%;">
                  <h4 class="mb-4">INGRESO DE USUARIOS</h4>
                  <ion-input class="input-login" maxlength="12" autofocus="true" type="text" placeholder="RUT" v-bind:value="rut" @ionInput="rut = formateaRut($event.target.value)" @keyup.enter="iniciarSesion();"></ion-input>
                  <ion-input class="input-login ion-margin-top" maxlength="50" type="password" v-model="clave" placeholder="CLAVE" @keyup.enter="iniciarSesion();"></ion-input>
          

                  <!-- <ion-button class="btn-login mt-3" color="dark" shape="round" expand="block" @click="iniciarSesion();">
                    <ion-icon name="log-in-outline"></ion-icon>
                    <ion-label style="margin-left:10px;">INGRESAR</ion-label>
                  </ion-button> -->

                  <button class="btn-block btn btn-dark btn-login shadow rounded-pill mt-3" @click="iniciarSesion()">
                    <ion-icon name="log-in-outline"></ion-icon>
                    INICIAR SESIÓN
                  </button>
                  <h6 class="text-center mt-3" @click="olvidasteClave();" style="color: #007bff; cursor:pointer;">¿Olvidaste tu clave?</h6>


                  <hr class="mt-5 mb-5"/>  

                  <!--<button @click="registrando_cliente = true;" class="btn btn-outline-dark btn-block shadow rounded-pill animated fadeIn mb-4 alto"><i class="fas fa-user-circle fa-fw mr-2"></i>CREAR CUENTA</button>-->
                  
                </div>
                
              </div>

              <div class="row justify-content-center text-muted">
                <div class="col-lg-6 col-md-12 col-sm-12 text-justify">
                  <p class="font-italic mb-1" style="font-size:15px;">
                    En este sistema podrá reportar eventos relacionados a la <strong>Empresa</strong>, 
                    los cuales podrian ser asociados a un problema de la <strong>Seguridad de la Información</strong>, 
                    area de <strong>Soporte Informatico</strong> o del area de <strong>Soporte Tecnico</strong>.</p>
                </div>
              </div>
              
              <div class="row text-muted mt-5">
                <div class="col text-center">
                  <p class="font-italic mb-1" style="font-size:14px;">Desarrollado por Inverluz S.A.</p>
                  <p class="font-italic" style="font-size:13px;">Copyright © {{this.anoActual}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>


      </div>


    </ion-content>
    
  </ion-page>
</template>

<script>
import { 
  IonPage, IonContent, IonIcon, IonLabel, toastController, IonRow, IonCol, IonSpinner, modalController, IonInput, isPlatform, alertController
} from '@ionic/vue';

import { addIcons           } from 'ionicons';
import { shieldOutline, logInOutline } from 'ionicons/icons';
import { defineComponent    } from 'vue';
import { Preferences        } from '@capacitor/preferences';
import { PushNotifications  } from '@capacitor/push-notifications';
import { Browser            } from '@capacitor/browser';

import ValidaLogin        from '../components/ValidaLogin.vue'
import OlvidasteClave     from '../components/ModalOlvidasteClave.vue'
import * as CryptoJS      from 'crypto-js';
import axios              from 'axios';
import {rutaBase, versionAndroid} from '@/plugins/variables';
import { cerrarSesion }   from '@/plugins/funciones.ts';


export default defineComponent({
  name: 'Login',
  components: {
    IonPage, IonContent, IonIcon, IonLabel, IonRow, IonCol, IonSpinner, IonInput
  },
  created() {
    this.validaSesion();
    addIcons({
      'shield-outline' : shieldOutline,
      'log-in-outline' : logInOutline
    });
    this.listarTurnos();
  },
  data() {
    return { 
      rut                 : '',
      clave               : '',
      cargando            : true,
      anoActual           : null,
      modalCodigo         : Object,
      modalOlvidasteClave : Object,
      muestraTurnos       : false,
      turnos              : [],
      actualizarApp       : false
    }
  },
  mounted(){
    this.anoActual = new Date();
    this.anoActual = this.anoActual.getFullYear();
    console.log(rutaBase);
    console.log(versionAndroid);
  },
  methods: {
    async listarTurnos(){
      axios.get(rutaBase+'/login/listarTurnos').then( resp => {
        if(resp.data.key == 1){         
          this.muestraTurnos  = true;
          this.turnos         = resp.data.turnos;         
        }
        else{
          this.muestraTurnos = false; 
        }
      }).catch((error) =>{
        console.log(error)
        this.muestraToast('ERROR AL CONECTARSE CON EL SERVIDOR.');
      });
    }, 

    async iniciarSesion(){
      this.cargando = true;
      if(!this.verificaRut(this.rut) || this.clave == null || this.clave == ''){
        this.muestraToast('DATOS INCORRECTOS!');
        this.cargando = false;
        return;
      }
      const rutLimpio       = this.rut.replace(/[.|-]/g, '').slice(0, -1);
      //console.log(rutLimpio);

      const claveEncrip     = CryptoJS.SHA1(CryptoJS.MD5(rutLimpio.toString()+this.clave.toString()).toString()).toString();
      const dato            = new URLSearchParams();
      dato.append('rut'     , rutLimpio.toString());
      dato.append('clave'   , claveEncrip);
      dato.append('ccodigo' , 0);
      dato.append('codigo'  , 0);
      dato.append('movil'   , 0);
      axios.post(rutaBase+'/login/iniciarSesion', dato).then( resp => {
        this.cargando = false;
        if(resp.data.key == 1){      
          this.muestraModalCodigo(rutLimpio.toString(), claveEncrip.toString());           
        }
        else if(resp.data.key == 2){
          this.muestraToast('TIENES MUCHOS INTENTOS DE ACCESO.');
        }
        else if(resp.data.key == 3){ // cambio de clave activo
          this.muestraModalCodigo(rutLimpio.toString(), claveEncrip.toString(), true, resp.data.usuario, resp.data.token);   
        }
        else if(resp.data.key == 0){
          this.muestraToast('DAT0S INCORRECTOS.');
        }
      }).catch((error) =>{
        this.cargando = false;
        console.log(error)
        this.muestraToast('ERROR AL CONECTARSE CON EL SERVIDOR.');
      });
    }, 

    async olvidasteClave(){
      this.modalOlvidasteClave = await modalController
        .create({
          component: OlvidasteClave,
          componentProps: {
            modal     :  this.modalOlvidasteClave
          },
          backdropDismiss: false
        });
      this.modalOlvidasteClave.present();
      const modalResponse = await this.modalOlvidasteClave.onDidDismiss();
      
      modalResponse.data && this.modalCloseHandler({...modalResponse.data})
    },

    async muestraModalCodigo(rut, clave, inicioDirecto=false, usuario=null, token=null){
      this.modalCodigo = await modalController
        .create({
          component: ValidaLogin,
          componentProps: {
            rutProp           :  rut,
            claveProp         :  clave,
            inicioDirectoProp :  inicioDirecto,
            usuarioProp       :  usuario,
            tokenProp         :  token,
            modal             :  this.modalCodigo
          },
          backdropDismiss: false
        });
      this.modalCodigo.present();
      const modalResponse = await this.modalCodigo.onDidDismiss();
      
      modalResponse.data && this.modalCloseHandler({...modalResponse.data})
    },

    modalCloseHandler(_value) {
      if(_value.validacion == true){
        this.$router.replace('/menu');
        location.reload();
      }
    },

    async muestraToast(msj='') {
      const toast = await toastController
        .create({
          message: msj,
          duration: 2000,
          cssClass: 'text-center'
        })
      return toast.present();
    },

    async validaVersion(plataforma){
      const dato = new URLSearchParams();
      dato.append('plataforma'  , plataforma);
      dato.append('version'     , versionAndroid);
      await axios.post(rutaBase+'/Login/validaVersion', dato).then( resp => {
        if(resp.data.key == 2){
          this.actualizarApp = true;
          this.muestraAlertActualizacion(resp.data.url);
        }
        else if(resp.data.key == 0){
          this.muestraToast('FALLA AL VALIDAR VERSION DE APP');
        }
      }).catch((error) =>{
        this.cargando = false;
        this.muestraToast('FALLA AL VALIDAR VERSION DE APP');
        console.log(error);
      });
    },

    async muestraAlertActualizacion(urlNueva){
      const alert = await alertController.create({
        header: 'Actualización',
        subHeader: 'PlayStore',
        message: 'Existe una nueva versión de la aplicación, actualízala para un correcto funcionamiento.',
        backdropDismiss: false,
        keyboardClose: false,
        buttons: [
          {
            text: 'ACTUALIZAR',
            role: 'confirm',
            handler: () => {
              console.log('Alert actualizacion');
              Browser.open({ url: urlNueva });
            },
          }
        ],
      });

      await alert.present();
    },

    async validaSesion(){
      let plataforma = 'web';
      // VALIDACION DE PERMISOS DE NOTIFICACION
      if((isPlatform('ios') || isPlatform('android') || isPlatform('mobile')) && !isPlatform('mobileweb') && !isPlatform('desktop')){
        const permStatus = await PushNotifications.requestPermissions();
        plataforma = 'movil';
        if(isPlatform('android')){
          // CONSULTAMOS SI LA VERSION ACTUAL ES LA ULTIMA
          await this.validaVersion('ANDROID');
        }
      }
      // VALIDACION DE TOKENS DE SESION
      const token   = await Preferences.get({ key: 'token_auth' });
      if (token.value != null && !this.actualizarApp){
        const dato = new URLSearchParams();
        dato.append('plataforma' , plataforma);
        const headers = { headers: { 'Authorization': `${token.value}` } };
        axios.post(rutaBase+'/Login/validaSesion', dato, headers).then( resp => {
          if (resp.status === 203) {
            cerrarSesion();
          }
          else if (resp.status === 200) {
            Preferences.get({ key: 'tipo_usuario' }).then(tipoUsuario =>{
              if(tipoUsuario.value == '1'){
                this.$router.replace({path: '/menu/administrador'})
              }
              else if(tipoUsuario.value == '2'){
                this.$router.replace({path: '/menu/soporte'})
              }
              else if(tipoUsuario.value == '3'){
                this.$router.replace({path: '/menu/soporte'})
              }
              else if(tipoUsuario.value == '4'){
                this.$router.replace({path: '/menu/normal'})
              }
              else if(tipoUsuario.value == '5'){
                this.$router.replace({path: '/menu/reportes'})
              }
              else if(tipoUsuario.value == '6'){
                this.$router.replace({path: '/menu/soporte'})
              }
              else if(tipoUsuario.value == '99'){
                this.$router.replace({path: '/menu/normal'})
              }
            });
          }
          else{
            this.cargando = false;
          }
        }).catch(() =>{
          this.cargando = false;
          this.muestraToast('SIN CONEXIÓN CON SERVIDORES.');
          this.$router.replace({path: '/error_conexion'});
        });
      }else{
        this.cargando = false;
      }
    },

    formateaRut(rut){
      const newRut = rut.replace(/\./g,'').replace(/[^k|K|\d]/g, '').replace(/-/g, '').trim().toUpperCase();
      const lastDigit = newRut.substr(-1, 1);
      const rutDigit = newRut.substr(0, newRut.length-1)
      let format = '';
      let i = 0;
      let j = 1;
      for (i = rutDigit.length - 1; i >= 0; i--) {
        const e = rutDigit.charAt(i);
        format = e.concat(format);
        if (j % 3 == 0 && j <= rutDigit.length - 1) {
          format = '.'.concat(format);
        }
        j++;
      }
      let formateado = "";
      if(format.length > 0){
        formateado = format.concat('-').concat(lastDigit);
      }
      else{
        formateado = lastDigit;
      }
      return formateado;
    },

    verificaRut(rut){
      let resp=false;
      if(rut != null && rut.toString().length >= 11){
        const dv = rut.substring(rut.length - 1, rut.length);
        rut = rut.replace(/[.|-]/g, '').slice(0, -1);
        if(rut.indexOf('K') == -1){
        //DESCOMENTAR EL IF Y LA LLAVE PARA VALIDAR CONTRA RUT 'ESPECIALES'
        //if(!rut.match(/(KK|0000000|1111111|2222222|3333333|4444444|5555555|6666666|7777777|8888888|9999999)/g)){
            let m=0,s=1;
            for(;rut;rut=Math.floor(rut/10))
              s=(s+rut%10*(9-m++%6))%11;
            const dvCalc= (s?s-1:'K').toString();
            if(dvCalc===dv) resp=true;
        // }
        }
      }
      return resp;
    }
  }
});
</script>

<style>
.btn-login {
  height: 50px!important;
  margin: 0!important;
}

.contenido {
  max-width: 600px!important;
}

.input-login input {
  border-radius: 50rem!important;
  border: 1px solid black!important;
  padding: .375rem .85rem!important;
  height: 50px!important;
  box-shadow: 0 .5rem 1rem rgba(0,0,0,.15)!important;
  text-align: left!important;
  color: black!important;
  background-color: white!important;
}

.input-login input:focus {
  border-color: #007bff!important;
}

.fondo-lg {
  min-height: 100% !important;
  min-width: 1280px !important;
  width: 100% !important;
  height: auto !important;
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  -webkit-background-size: cover !important;
  -moz-background-size: cover !important;
  -o-background-size: cover !important;
  background-size: cover !important;
}

.fondo-sm {
  -webkit-background-size: cover !important;
   -moz-background-size: cover !important;
   -o-background-size: cover !important;
   background-size: cover !important;
   width: 100% !important;
   text-align: center !important;
}

.fondo1 {
  background: linear-gradient(rgba(0%,0%,0%,.5), rgba(0%,0%,0%,.8)), url('/assets/imgs/fondo.jpg') no-repeat center;
}

.fondo-transparente {
  background: rgba(34, 34, 34, 0.9) !important
}

</style>


